import * as React from 'react';
import { Button } from '@roo/roo';
import { useHistory } from 'react-router-dom';
import { getOrderId } from '../api';

interface P {
    distributeId: string;
}

function fetchOrderIdAndJump(distributeId: string, history: any) {
    getOrderId(distributeId).then(res => {
        const { orderTime, orderViewId } = res.data;
        history.push(`/main/v3/order?orderId=${orderViewId}&startTime=${orderTime}`);
    });
}
const JumpOrderBtn: React.FC<P> = ({ distributeId }) => {
    const history = useHistory();
    return (
        <Button type="text" onClick={() => fetchOrderIdAndJump(distributeId, history)}>
            查看订单
        </Button>
    );
};

export default JumpOrderBtn;
